import { Box, keyframes, SxProps, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

const blink = keyframes`50% { opacity: 0; }`

type P = {
    messages: string[]
    typingSpeed?: number
    deletingSpeed?: number
    delayAfterTyping?: number
    delayAfterDeleting?: number
    sx?: SxProps
}

const TypewriterLoader = ({ messages, typingSpeed = 80, deletingSpeed = 40, delayAfterTyping = 1500, delayAfterDeleting = 800, sx = {} }: P) => {
    const [i, setI] = useState(0) // character index
    const [deleting, setDeleting] = useState(false)
    const [msgIndex, setMsgIndex] = useState(() => Math.floor(Math.random() * messages.length))

    const currentMessage = messages[msgIndex]

    useEffect(() => {
        const atEnd = !deleting && i === currentMessage.length
        const atStart = deleting && i === 0

        const delay = atEnd
            ? delayAfterTyping
            : atStart
                ? delayAfterDeleting
                : deleting
                    ? deletingSpeed
                    : typingSpeed

        const t = setTimeout(() => {
            if (atEnd) {
                setDeleting(true)
            } else if (atStart) {
                setDeleting(false)

                let nextIndex = msgIndex
                while (nextIndex === msgIndex && messages.length > 1) {
                    nextIndex = Math.floor(Math.random() * messages.length)
                }
                setMsgIndex(nextIndex)
            } else {
                setI(prev => prev + (deleting ? -1 : 1))
            }
        }, delay)

        return () => clearTimeout(t)
    }, [
        i,
        deleting,
        msgIndex,
        currentMessage,
        messages,
        typingSpeed,
        deletingSpeed,
        delayAfterTyping,
        delayAfterDeleting
    ])

    return (
        <Box sx={{ height: '1.1em', display: 'inline-flex', alignItems: 'center', ...sx }}>
            <Typography component='span' sx={{ fontFamily: 'monospace' }} color='text.secondary'>
                {currentMessage.slice(0, i)}
            </Typography>
            <Box
                component='span'
                sx={{
                    width: '2px',
                    height: '1.1em',
                    bgcolor: 'text.primary',
                    animation: `${blink} 1s infinite`
                }}
            />
        </Box>
    )
}

export default TypewriterLoader
